import { createSelector } from '@reduxjs/toolkit';

export const selectBookingRequesting = (state) => state.booking.requesting;
export const selectBookingError = (state) => state.booking.error;

export const selectBookingId = (state) => state.booking.id;
export const selectBookingUID = (state) => state.booking.uid;
export const selectBookingSID = (state) => state.booking.sid;
export const selectBookingIsAdded = (state) => state.booking.isAdded;
export const selectBookingIsActive = (state) => state.booking.isActive;

export const selectBookingView = (state) => state.booking.view;
export const selectBookingItems = (state) => state.booking.items;
export const selectBookingRentalType = (state) => state.booking.rentalType;
export const selectBookingActiveItem = (state) => state.booking.activeItem;

export const selectBookingBlockContent = createSelector(
  (state) => state.booking,
  (booking) => ({
    heading: booking.heading,
    items: booking.items,
    view: booking.view,
    layout: booking.layout,
    rentalType: booking.rentalType,
  }),
);

export const selectBookingBlockDesign = createSelector(
  (state) => state.booking,
  (booking) => ({
    containerDesign: booking.containerDesign,
    itemDesign: booking.itemDesign,
    buttonDesign: booking.buttonDesign,
    view: booking.designView,
    layout: booking.designLayout,
    itemTextAlign: booking.itemTextAlign,
    itemTitleSize: booking.itemTitleSize,
    itemLayout: booking.itemLayout,
    itemFields: booking.itemFields,
    itemColumns: booking.itemColumns,
  }),
);

export const selectBookingHeading = (state) => state.booking.heading;

export const selectBookingContainerDesign = (state) => state.booking.containerDesign;
export const selectBookingItemDesign = (state) => state.booking.itemDesign;
export const selectBookingButtonDesign = (state) => state.booking.buttonDesign;
